import React, { useEffect, useState } from "react";
import { OneMealService } from "../../services/OneMealService";
import { useRefresh } from "react-admin";
import CircularLoader from "../Common/CircularLoader";
import EmptyListPlaceholder from "../Common/EmptyListPlaceholder";
import OneMealServiceVendorMetaShow from "./OneMealServiceVendorMetaShow";
import ChefForPartyService from "../../services/ChefForPartyService";

interface InputProps {
  oneMealServiceId: number;
  forparty?: boolean;
}

const oneMealService = new OneMealService();
const partyService = new ChefForPartyService();

const OneMealVendorPayoutTab = (props: InputProps) => {
  let [subData, setSubData] = useState<any>(null);
  let [isLoading, setIsLoading] = useState<boolean>();
  const refresh = useRefresh();

  const refreshData = (oneMealServiceId: number, forParty: boolean) => {
    setIsLoading(true);
    if(forParty){
      return partyService
      .getVendorPayoutForChefForParty(oneMealServiceId)
      .then((data) => {
        setSubData(data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
    }
    oneMealService
      .getVendorPayoutForOneMeal(oneMealServiceId)
      .then((data) => {
        setSubData(data?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    refreshData(props?.oneMealServiceId, !!props?.forparty);
  }, [props?.oneMealServiceId, props?.forparty]);

  return (
    <div>
      {isLoading ? (
        <CircularLoader />
      ) : (
        <div>
          {subData &&
            Array.isArray(subData) &&
            (subData?.length > 0 ? (
              <OneMealServiceVendorMetaShow
                data={subData}
                updateParentData={refresh}
              />
            ) : (
              <EmptyListPlaceholder message="No VendorPayout Data Found" />
            ))}
        </div>
      )}
    </div>
  );
};

export default OneMealVendorPayoutTab;
